import { Utils } from "@adobe/aem-react-editable-components";
import { ChunkExtractorManager } from "@loadable/server";
import AEMPublishRouter from "aem/AEMPublishRouter";
import AboveNavPromo from "component-promo/AboveNavPromo";
import PromoDialogContainer from "component-promo/PromoDialogContainer";
import ReloadForATGController from "component-reload-for-atg-controller";
import ScrollManager from "component-scroll-manager";
import ContainerApp, { AppDefaultProps } from "container-app";
import Provider from "custom-providers/Provider";
import express from "express";
import { processEnvServer } from "hooks/useSsrHooks";
import React from "react";
import { BrowserRouter, StaticRouter } from "react-router-dom";
import memoize from "utils/memoize";
import type { ClientType } from "graphql-client/client-type";
import { useEnv } from "hooks/useEnv";
import yn from "yn";
import "aem/import-components.publish";
import AEMPublishPage from "aem/AEMPublishPage";
import { getModelClient } from "aem/CustomModelClientSide";
import graphqlClient from "graphql-client";
import { QAStickyInfo, CmrDebugContent } from "components/QAStickInfo";

if (process.env.NODE_ENV !== "development") {
  /* we move the app inside src and use the scss to join with the fonts/index.scss- only these 2 together becase they dont change often so we can cache for long time */
  require("../app.scss");
  /* importing the tailwind generated css so can be hash and put on static assets */
  require("../tw.css");
}
const isEditor = Utils.isInEditor();
const env = useEnv();
const showDebug =
  (env.ENV_ID !== "PROD" && yn(env.FEATURE_CMR)) ||
  (env.ENV_ID !== "PROD" && yn(env.FEATURE_BFF_ENDPOINTS_EXPOSER));

const App = (props: {
  location?: string;
  extractor?: any;
  cookiePersistor?: any;
  req?: express.Request;
  isSSR?: boolean;
  footerModel?: any;
  routerContext?: any;
  client: ClientType;
  isLocalStorageUpdate?: boolean;
}) => {
  const modelClient = getModelClient({ client: graphqlClient });
  const aemPublishPage = AEMPublishPage;
  return processEnvServer ? (
    <ChunkExtractorManager extractor={props.extractor}>
      <StaticRouter location={props.location} context={props.routerContext}>
        <Provider
          cookiePersistor={props.cookiePersistor}
          req={props.req}
          client={props.client}
        >
          <ReloadForATGController>
            <ContainerApp>
              {showDebug && (
                <QAStickyInfo>
                  <CmrDebugContent />
                </QAStickyInfo>
              )}
              <AboveNavPromo />
              <AEMPublishRouter
                client={props.client}
                aemPublishPage={aemPublishPage}
                modelClient={modelClient}
              />
            </ContainerApp>
            <PromoDialogContainer />
          </ReloadForATGController>
        </Provider>
      </StaticRouter>
    </ChunkExtractorManager>
  ) : (
    <BrowserRouter>
      <Provider client={props.client}>
        <ReloadForATGController>
          {!isEditor && <ScrollManager />}
          <ContainerApp
            rootStyle={{
              minHeight: isEditor
                ? "100%"
                : (AppDefaultProps?.rootStyle as any)?.minHeight
            }}
          >
            {showDebug && (
              <QAStickyInfo>
                <CmrDebugContent />
              </QAStickyInfo>
            )}
            <AboveNavPromo />
            <AEMPublishRouter
              client={props.client}
              aemPublishPage={aemPublishPage}
              modelClient={modelClient}
              isLocalStorageUpdate={props.isLocalStorageUpdate}
            />
          </ContainerApp>
          <PromoDialogContainer />
        </ReloadForATGController>
      </Provider>
    </BrowserRouter>
  );
};

export default memoize(App);
